import styled from '@emotion/styled';
import { handyBreakpoint } from '~Styles/breakpoints';

export const Wrapper = styled.div`
  padding-right: 50px;
  padding-bottom: 50px;
  min-width: 540px;
  max-width: 700px;
  overflow: auto;
  margin-top: 24px;

  ${handyBreakpoint} {
    width: 100%;
    padding: 0 16px;
    min-width: 0;
    box-sizing: border-box;
    margin-top: 0;
  }
`;

export const Table = styled.div``;

export const TableWrapper = styled.div``;

export const HeaderRow = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 18px;
  padding-bottom: 4px;
  margin-bottom: 4px;
  margin-top: 36px;
  border-bottom: 1px solid var(--colorBlueGray200);
`;

export const Row = styled.div<{ extraMarginTop?: boolean }>`
  display: flex;
  font-size: 16px;
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--colorBlueGray200);
  margin-top: ${({ extraMarginTop }) => (extraMarginTop ? '36px' : '0')};
`;

export const Text = styled.div<{ isNumber?: boolean; indent?: boolean; bold?: boolean }>`
  width: 180px;
  margin-left: ${({ indent }) => (indent ? '50px' : '30px')};
  text-align: right;
  font-weight: ${({ bold }) => (bold ? '600' : 'inherit')};
  // Set numbers to mono font
  font-family: ${({ isNumber }) => (isNumber ? 'monospace' : 'inherit')};

  &:first-child {
    margin: 0 auto 0 0;
    text-align: left;
  }

  &:nth-child(2):not(:last-child) {
    width: 120px;

    ${handyBreakpoint} {
      width: 70px;
    }
  }

  &:nth-child(3) {
    ${handyBreakpoint} {
      width: 100px;
    }
  }
`;

export const InfoText = styled.p`
  margin: 0;
  font-style: italic;
`;

export const Info = styled.div`
  margin: 36px 0;

  p {
    margin: 0;
  }
`;

export const OrgInfo = styled.div`
  margin: 36px 0;
  color: #a7a7a7;
`;

export const StaffDropdown = styled.select`
  padding: 10px 0;
  width: 350px;
  text-align: center;
  outline: 0;
  margin-top: 15px;
  font-size: 25px;
  font-weight: 300;
  border: 0;
  background: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  appearance: none;
`;

export const CategoriesList = styled.ul`
  padding-left: 0;
  margin: 0;

  li {
    list-style: none;
  }

  ul {
    list-style: none;
    padding-left: 16px;
  }
`;
